import { Component, inject, TemplateRef } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
  NgbCollapseModule,
  NgbDropdownModule,
  NgbModal,
  NgbModalModule,
  NgbOffcanvas,
} from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import { GlobalConstants } from '../../global-constants';
import { lcSidebar } from '../lc-sidebar/lc-sidebar';
import { HOW_IT_WORKS_STEPS } from '../../shared/wizard-steps';
import { CurrentUserService } from '../../shared/auth/current-user.service';
import { CadixChatService } from '../../shared/cadix-chat/cadix-chat.service';

@Component({
  selector: 'header[lcNavbar], lc-navbar',
  imports: [
    NgbCollapseModule,
    NgbDropdownModule,
    NgbModalModule,
    RouterLink,
    RouterLinkActive,
    lcSidebar,
  ],
  templateUrl: './lc-navbar.html',
  styleUrl: './lc-navbar.scss',
})
export class lcNavbar {
  protected readonly appName = GlobalConstants.appInfo.appName;
  protected readonly mainNav = GlobalConstants.mainNav;
  protected readonly userNav = GlobalConstants.userNav;
  protected readonly howItWorksSteps = HOW_IT_WORKS_STEPS;
  private readonly currentUserService = inject(CurrentUserService);
  private readonly cadixChat = inject(CadixChatService);
  protected readonly displayName = this.currentUserService.displayName;
  protected readonly userInitials = this.currentUserService.initials;
  private readonly oktaAuth = inject(OKTA_AUTH);
  private offcanvasService = inject(NgbOffcanvas);
  private readonly modalService = inject(NgbModal);
  closeResult = '';

  openMainNav(content: TemplateRef<any>) {
    this.offcanvasService.open(content, {
      position: 'start',
      panelClass: 'text-bg-navy',
    });
  }

  openUserNav(content: TemplateRef<any>) {
    this.offcanvasService.open(content, {
      position: 'end',
      panelClass: 'text-bg-navy',
    });
  }

  openHowItWorks(content: TemplateRef<unknown>) {
    this.modalService.open(content, {
      centered: true,
      ariaLabelledBy: 'how-it-works-title',
      scrollable: true,
    });
  }

  protected async signOut(): Promise<void> {
    this.cadixChat.clearSessionStorage();
    await this.oktaAuth.signOut();
  }
}
